//import { Vue, i18n } from 'Components/vue';
import { rDpdWidget } from "Components/dpd";

/* if (document.querySelector('#dpd-parcelshop-map-pickup-el')) {
    import('Components/vue/mapPickup/index.vue').then((module) => {
        window.$_dpdParcelshop = new Vue({
            i18n,
            render: h => h(
                module.default,
                {
                    props: {
                        branchesData: window.dpdParcelshopBranchesData,
                        $modalInstance: $('#dpd-parcelshop-pickup-modal'),
                        mapTrigger: document.querySelector('[r-dpd-parcelshop-trigger]'),
                        pickupInput: document.querySelector('input[r-dpd-parcelshop-input]'),
                        branchEmptyEl: document.querySelector('[r-dpd-parcelshop-empty]'),
                        branchSelectedEl: document.querySelector('[r-dpd-parcelshop-selected]'),
                        branchNameEl: document.querySelector('[r-dpd-parcelshop-selected-branch]'),
                        branchAddressEl: document.querySelector('[r-dpd-parcelshop-selected-address]'),
                        markerIcons: {
                            your_location: {
                                url: '/img/markers/your_location.svg',
                                size: [50, 50],
                                anchor: { left: 25, top: 25 }
                            },
                            normal: {
                                url: '/img/markers/dpd.svg',
                                size: [56, 68],
                                anchor: { left: 28, top: 54 }
                            },
                            selected: {
                                url: '/img/markers/dpd_selected.svg',
                                size: [56, 68],
                                anchor: { left: 28, top: 54 }
                            }
                        }
                    }
                }
            )
        }).$mount("#dpd-parcelshop-map-pickup-el");
    })
} */

document.addEventListener("DOMContentLoaded", async () => {
    let dpdApiKey, dpdCountry;
    const baseUrl = window.location.origin;

    if (baseUrl.includes("kabel.rshop.sk")) {
        dpdApiKey = "n8h0h9lupyxen7zv7refc5bc9wwe5lg1";
        dpdCountry = "sk";
    } else if (baseUrl.includes("kypo.rshop.sk")) {
        dpdApiKey = "fm1hk4ffz3yu74jlongrotymztcz3s6u";
        dpdCountry = "sk";
    } else if (baseUrl.includes("kabel.sk")) {
        dpdApiKey = "9bn1bfrlelukho2f67t9dkqoikbsazg0";
        dpdCountry = "sk";
    } else if (baseUrl.includes("kypo.sk")) {
        dpdApiKey = "3ggpvu5rrf04r2s33e2aam936rcip0sy";
        dpdCountry = "sk";
    } else {
        dpdApiKey = "y4tbma523r5nptrrjs45yt347zr36a2d";
        dpdCountry = "sk";
    }

    await rDpdWidget.init(dpdApiKey, {
        country: dpdCountry,
        allowedCountries: [dpdCountry],
    });
});

if (document.querySelector('[r-zasielkovna-input]')) {
    (async () => {
        await import('Lib/packeta.library')
        await import('Components/zasielkovna')
    })()
}
